import { render, staticRenderFns } from "./PageDialog.vue?vue&type=template&id=f2a1d596&scoped=true&"
import script from "./PageDialog.vue?vue&type=script&lang=ts&"
export * from "./PageDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PageDialog.vue?vue&type=style&index=0&id=f2a1d596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a1d596",
  null
  
)

export default component.exports